import BaseRegistrationMessage from "./BaseRegistration.message";

const CLASS_REQUIRED = "Please select the class for the teacher.";
const SUBJECT_REQUIRED = "Please select at least one subject from teacher.";
const BASE_SALARY_REQUIRED = "Please provide base salaray for the teacher.";
const SCHOOL_BRANCH_REQUIRED = "Please select branch for the teacher.";
const SCHOOL_BLOCK_REQUIRED = "Please select block for the teacher.";
const JOB_TYPE_REQUIRED = "Please select job type for the teacher.";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  ...BaseRegistrationMessage,
  CLASS_REQUIRED,
  SUBJECT_REQUIRED,
  BASE_SALARY_REQUIRED,
  SCHOOL_BRANCH_REQUIRED,
  SCHOOL_BLOCK_REQUIRED,
  JOB_TYPE_REQUIRED,
};
